<template>
  <div class="container">
    <div class="row">
      <div class="col bg-nv-primary pa-5">
        <div class="row">
          <div class="center-content-sm col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="content">
              <img class="icon-flavor-detail mb-100 mt-5" :src="detail.url_icon" :alt="detail.name">
              <p class="color-blue font-general-r text-ingredients">
                <b>Ingredientes:</b> {{ detail.ingredients }}
              </p>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="content">
              <h3 class="color-blue font-general-r text-center mt-5">INFORMACIÓN NUTRICIONAL</h3> <br>
              <div v-for="item in detail.detail_flavor" :key="item.id">
                <div class="content-information-nutrition">
                  <span class="color-blue font-general-r h5 font-weight-bold">
                    {{ item.nutritional_information.name }}
                  </span>
                  <span class="color-blue font-general-r h5 font-weight-bold">{{ item.value }}</span>
                </div>
                <div class="content-information-nutrition" v-for="item in item.more_detail" :key="item.field">
                  <span class="color-blue font-general-l h5 ml-10">
                    {{ item.field }}
                  </span>
                  <span class="color-blue font-general-l h5 ">{{ item.value }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['detail']
}
</script>

<style scoped>
.content-information-nutrition {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px
}
</style>
